var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product-page" },
    [
      _vm.hasCollection
        ? _c(
            "div",
            {
              staticClass: "back-button",
              on: {
                click: function($event) {
                  return _vm.goBack()
                }
              }
            },
            [_vm._v("< BACK")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "main-title-container" }, [
        _c("div", [
          _c("p", { staticClass: "main-title" }, [
            _vm._v(_vm._s(_vm.curatedBoxTitle))
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "main-subtitle" }, [
            _vm._v(_vm._s(_vm.description))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "box-qty-container" }, [
          _c("div", { staticClass: "input-container" }, [
            _c(
              "div",
              {
                staticClass: "box-qty-input-container",
                class: _vm.canAddMore ? "" : "no-more"
              },
              [
                _c(
                  "button",
                  {
                    attrs: { disabled: _vm.selectedBoxQty < _vm.minQty },
                    on: {
                      click: function($event) {
                        return _vm.incrementBoxQty(false)
                      }
                    }
                  },
                  [_vm._v("-")]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedBoxQty,
                      expression: "selectedBoxQty"
                    }
                  ],
                  attrs: { type: "number", min: "1" },
                  domProps: { value: _vm.selectedBoxQty },
                  on: {
                    blur: function($event) {
                      return _vm.changeBoxQty(null)
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.selectedBoxQty = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: {
                          content: "Not enough inventory",
                          container: false
                        },
                        expression:
                          "{content: 'Not enough inventory', container:false}"
                      }
                    ],
                    on: {
                      click: function($event) {
                        return _vm.incrementBoxQty(true)
                      }
                    }
                  },
                  [_vm._v("+")]
                )
              ]
            ),
            _vm._v(" "),
            _vm.minQty > 1
              ? _c("p", { staticClass: "min-alert" }, [
                  _vm._v("Minimum: " + _vm._s(_vm.minQty))
                ])
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "curated-boxes-page" }, [
        _c("div", { staticClass: "curated-boxes-images-container" }, [
          _c("p", { staticClass: "main-title" }, [
            _vm._v("Box preview pictured below: " + _vm._s(_vm.currentPrice))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item-box" }, [
            _c("img", {
              staticClass: "box-image",
              attrs: {
                width: "649",
                height: "492",
                src:
                  "https://cdn.shopify.com/s/files/1/1363/8433/files/emptybox_1.png?v=1659452617"
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "addon-images" },
              _vm._l(_vm.selectedAddonProducts, function(addonProduct) {
                return _c(
                  "div",
                  { key: addonProduct.id, staticClass: "addon-image" },
                  [
                    _c("AddonBoxProduct", {
                      attrs: {
                        product: addonProduct,
                        cartProducts: _vm.selectedAddonProducts,
                        boxQty: _vm.boxQty
                      }
                    })
                  ],
                  1
                )
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "products-container-title" }, [
            _vm._v("What's inside: Scroll to review your gift")
          ]),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "products-container" },
            _vm._l(_vm.selectedAddonProducts, function(addonProduct) {
              return _c("li", { key: addonProduct.variants[0].id }, [
                _c("div", { staticClass: "addon-container" }, [
                  _c("div", { staticClass: "image-container" }, [
                    _c("img", {
                      staticClass: "main-image",
                      attrs: { src: _vm._f("getProductImage")(addonProduct) }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "product-information" }, [
                    _c("div", [
                      _c("p", { staticClass: "title" }, [
                        _vm._v(_vm._s(addonProduct.title))
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "price" }, [
                        _vm._v(_vm._s(addonProduct.variants[0].price))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "product-qty-container" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: addonProduct.quantity,
                              expression: "addonProduct.quantity"
                            }
                          ],
                          on: {
                            change: [
                              function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  addonProduct,
                                  "quantity",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                              function($event) {
                                return _vm.updateAddon(addonProduct)
                              }
                            ]
                          }
                        },
                        _vm._l(_vm.addonMaxQty(addonProduct), function(qty) {
                          return _c(
                            "option",
                            { key: qty, domProps: { value: qty } },
                            [_vm._v(_vm._s(qty))]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "delete-button",
                        attrs: {
                          src:
                            "https://cdn.shopify.com/s/files/1/1363/8433/files/trash_05a3e1b5-b394-4f91-aaf3-599964c057cb.svg?v=1659632833"
                        },
                        on: {
                          click: function($event) {
                            return _vm.removeProduct(addonProduct)
                          }
                        }
                      })
                    ])
                  ])
                ])
              ])
            }),
            0
          ),
          _vm._v(" "),
          !_vm.isMobile
            ? _c("div", { staticClass: "product-legend" }, [
                _c("p", { staticClass: "title" }, [
                  _vm._v(
                    "Ship exactly how you need. In checkout, you'll be able to:"
                  )
                ]),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _vm._m(2)
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "curated-boxes-main-container" }, [
          _c("div", { staticClass: "addons-container" }, [
            _c("p", { staticClass: "title" }, [
              _vm._v("Step 1: Add or Swap Items")
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "subtitle" }, [
              _vm._v("Scroll to add additional products. Price will change")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "tab-container" }, [
              !_vm.isLoading
                ? _c(
                    "div",
                    { staticClass: "addon-products-container" },
                    [
                      _vm._l(_vm.filteredProducts, function(addonProduct, i) {
                        return _c(
                          "div",
                          { key: i, staticClass: "addon-container" },
                          [
                            _c("AddonProduct", {
                              attrs: {
                                product: addonProduct,
                                cartProducts: _vm.selectedAddonProducts,
                                boxQty: _vm.boxQty,
                                maxCapacity: _vm.maxCapacity,
                                currentCapacity: _vm.currentCapacity
                              },
                              on: { changeboxqty: _vm.changeBoxQty }
                            })
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _vm.filteredProducts.length < 1
                        ? _c("div", { staticClass: "spinner-container" }, [
                            _c("div", { staticClass: "spinner" })
                          ])
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          !_vm.noCard && !_vm.paidCard
            ? _c(
                "div",
                {
                  staticClass: "write-container",
                  attrs: { id: "write-container" }
                },
                [
                  _c("div", { staticClass: "pick-card-container" }, [
                    _c("div", { staticClass: "pick-card-header" }, [
                      _c("p", { staticClass: "title" }, [
                        _vm._v("Step 2: Pick Your Card")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "blank-card-container" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.isNoCard,
                              expression: "isNoCard"
                            }
                          ],
                          attrs: { id: "noCard", type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.isNoCard)
                              ? _vm._i(_vm.isNoCard, null) > -1
                              : _vm.isNoCard
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.isNoCard,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 && (_vm.isNoCard = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.isNoCard = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.isNoCard = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "noCard" } }, [
                          _vm._v("Skip your Card")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.showCardAlert
                      ? _c("p", { staticClass: "red-alert" }, [
                          _vm._v("Please select a card")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isNoCard && _vm.cardProducts.length > 0
                      ? _c(
                          "div",
                          { staticClass: "cards-container" },
                          _vm._l(_vm.sortedCards, function(card) {
                            return _c(
                              "div",
                              {
                                key: card.id,
                                staticClass: "card-container",
                                class:
                                  _vm.selectedCard.id == card.id
                                    ? "selected"
                                    : "",
                                on: {
                                  click: function($event) {
                                    return _vm.selectCard(card)
                                  }
                                }
                              },
                              [
                                _vm.selectedCard.id == card.id
                                  ? _c("img", {
                                      staticClass: "green-check",
                                      attrs: {
                                        src:
                                          "https://cdn.shopify.com/s/files/1/1363/8433/files/check-circle.svg?v=1658433688"
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("img", {
                                  staticClass: "main-image lazyload",
                                  attrs: {
                                    width: "125",
                                    height: "125",
                                    "data-src": _vm._f("getProductImage")(card)
                                  }
                                })
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  !_vm.isNoCard
                    ? _c("div", { staticClass: "write-header" }, [
                        _c("p", { staticClass: "title" }, [
                          _vm._v("Write Your Note")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "blank-card-container" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.isEmptyMessage,
                                expression: "isEmptyMessage"
                              }
                            ],
                            attrs: { id: "blankCard", type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(_vm.isEmptyMessage)
                                ? _vm._i(_vm.isEmptyMessage, null) > -1
                                : _vm.isEmptyMessage
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.isEmptyMessage,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.isEmptyMessage = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.isEmptyMessage = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.isEmptyMessage = $$c
                                }
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "blankCard" } }, [
                            _vm._v("Leave the card blank")
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isNoCard && !_vm.isEmptyMessage
                    ? _c("div", { staticClass: "form-container" }, [
                        _c("p", { staticClass: "purple-span" }, [
                          _vm._v(
                            "Type in your message below. A real human will hand write your message and include it in your gift."
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "message-container" }, [
                          _vm.showAlert
                            ? _c("p", { staticClass: "red-alert" }, [
                                _vm._v("Please type your message below")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "message" } }, [
                            _vm._v("Your Message:")
                          ]),
                          _vm._v(" "),
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.message.text,
                                expression: "message.text"
                              }
                            ],
                            attrs: {
                              disabled: _vm.isEmptyMessage,
                              placeholder: "Start typing here...",
                              maxlength: "200",
                              cols: "30",
                              rows: "3",
                              id: "message"
                            },
                            domProps: { value: _vm.message.text },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.message,
                                  "text",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "from-container" }, [
                          _vm.showAlert
                            ? _c("p", { staticClass: "red-alert" }, [
                                _vm._v("Please type your message below")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "from" } }, [
                            _vm._v("From:")
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.message.from,
                                expression: "message.from"
                              }
                            ],
                            attrs: {
                              disabled: _vm.isEmptyMessage,
                              placeholder: "Your Name",
                              maxlength: "200",
                              id: "from",
                              type: "text"
                            },
                            domProps: { value: _vm.message.from },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.message,
                                  "from",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass: "purple-span",
                              class: _vm.remainingCharacters < 0 ? "red" : ""
                            },
                            [
                              _vm._v(
                                "Character Remaining " +
                                  _vm._s(_vm.remainingCharacters)
                              )
                            ]
                          )
                        ])
                      ])
                    : _vm._e()
                ]
              )
            : !_vm.noCard && _vm.paidCard
            ? _c("div", { staticClass: "write-container" }, [
                _c("div", { staticClass: "pick-card-container" }, [
                  _c("div", { staticClass: "paid-card-header" }, [
                    _c("div", { staticClass: "selection-container" }, [
                      _c("p", { staticClass: "title" }, [
                        _vm._v("Add a handwritten card for $6")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "blank-card-container" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selectedPaidCard,
                              expression: "selectedPaidCard"
                            }
                          ],
                          attrs: { id: "blankCard", type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.selectedPaidCard)
                              ? _vm._i(_vm.selectedPaidCard, null) > -1
                              : _vm.selectedPaidCard
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.selectedPaidCard,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.selectedPaidCard = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.selectedPaidCard = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.selectedPaidCard = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "blankCard" } }, [
                          _vm._v("I want a card")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "subtitle" }, [
                      _vm._v(
                        "\n                            Include a card with each gift. Our team will handwrite your message for you and ship along with the item you choose, directly to your recipient\n                        "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.selectedPaidCard && _vm.sortedCards.length > 0
                    ? _c(
                        "div",
                        { staticClass: "cards-container" },
                        _vm._l(_vm.sortedCards, function(card) {
                          return _c(
                            "div",
                            {
                              key: card.id,
                              staticClass: "card-container",
                              class:
                                _vm.selectedCard.id == card.id
                                  ? "selected"
                                  : "",
                              on: {
                                click: function($event) {
                                  return _vm.selectCard(card)
                                }
                              }
                            },
                            [
                              _vm.selectedCard.id == card.id
                                ? _c("img", {
                                    staticClass: "green-check",
                                    attrs: {
                                      src:
                                        "https://cdn.shopify.com/s/files/1/1363/8433/files/check-circle.svg?v=1658433688"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("img", {
                                staticClass: "main-image",
                                attrs: { src: _vm._f("getProductImage")(card) }
                              })
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm.selectedPaidCard
                  ? _c("div", { staticClass: "write-header" }, [
                      _c("p", { staticClass: "title" }, [
                        _vm._v("Write Your Note")
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedPaidCard
                  ? _c("div", { staticClass: "form-container" }, [
                      _c("p", { staticClass: "purple-span" }, [
                        _vm._v(
                          "Type in your message below. A real human will hand write your message and include it in your gift."
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "message-container" }, [
                        _vm.showAlert
                          ? _c("p", { staticClass: "red-alert" }, [
                              _vm._v("Please type your message below")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "message" } }, [
                          _vm._v("Your Message:")
                        ]),
                        _vm._v(" "),
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.message.text,
                              expression: "message.text"
                            }
                          ],
                          attrs: {
                            disabled: !_vm.selectedPaidCard,
                            placeholder: "Start typing here...",
                            maxlength: "200",
                            cols: "30",
                            rows: "3",
                            id: "message"
                          },
                          domProps: { value: _vm.message.text },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.message, "text", $event.target.value)
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "from-container" }, [
                        _vm.showAlert
                          ? _c("p", { staticClass: "red-alert" }, [
                              _vm._v("Please type your message below")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "from" } }, [
                          _vm._v("From:")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.message.from,
                              expression: "message.from"
                            }
                          ],
                          attrs: {
                            disabled: !_vm.selectedPaidCard,
                            placeholder: "Your Name",
                            maxlength: "200",
                            id: "from",
                            type: "text"
                          },
                          domProps: { value: _vm.message.from },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.message, "from", $event.target.value)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass: "purple-span",
                            class: _vm.remainingCharacters < 0 ? "red" : ""
                          },
                          [
                            _vm._v(
                              "Character Remaining " +
                                _vm._s(_vm.remainingCharacters)
                            )
                          ]
                        )
                      ])
                    ])
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isMobile
            ? _c("div", { staticClass: "end-buttons-container" }, [
                _c(
                  "button",
                  {
                    staticClass: "happybox-button yellow",
                    on: {
                      click: function($event) {
                        return _vm.openValidations(false)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.addBtnTxt))]
                ),
                _vm._v(" "),
                _vm.isPreorder
                  ? _c("p", { staticClass: "preorder-alert" }, [
                      _vm._v("Ships in time for mid December delivery")
                    ])
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.noCard && _vm.recoProducts.length > 0
            ? _c(
                "div",
                { staticClass: "more-gifts" },
                [
                  _c("p", { staticClass: "main-title" }, [
                    _vm._v("More Gifts")
                  ]),
                  _vm._v(" "),
                  !_vm.isMobile
                    ? _c(
                        "div",
                        { staticClass: "products-container" },
                        _vm._l(_vm.recoProducts, function(product) {
                          return _c(
                            "div",
                            {
                              key: product.id,
                              staticClass: "product-container",
                              on: {
                                click: function($event) {
                                  return _vm.selectNewProduct(product)
                                }
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: _vm._f("getProductImage")(product)
                                }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "curated-footer" }, [
                                _c("div", { staticClass: "curated-desc" }, [
                                  _c("p", { staticClass: "title" }, [
                                    _vm._v(_vm._s(product.title))
                                  ]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "price" }, [
                                    _vm._v(
                                      _vm._s(_vm._f("moneyFormat")(product))
                                    )
                                  ])
                                ])
                              ])
                            ]
                          )
                        }),
                        0
                      )
                    : _vm.recoProducts.length > 0
                    ? _c(
                        "VueSlickCarousel",
                        {
                          attrs: {
                            infinite: true,
                            dots: true,
                            arrows: false,
                            slidesToShow: 3,
                            slidesToScroll: 1
                          }
                        },
                        _vm._l(_vm.recoProducts, function(product) {
                          return _c(
                            "div",
                            {
                              key: product.id,
                              staticClass: "product-container",
                              on: {
                                click: function($event) {
                                  return _vm.selectNewProduct(product)
                                }
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: _vm._f("getProductImage")(product)
                                }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "curated-footer" }, [
                                _c("div", { staticClass: "curated-desc" }, [
                                  _c("p", { staticClass: "title" }, [
                                    _vm._v(_vm._s(product.title))
                                  ]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "price" }, [
                                    _vm._v(
                                      _vm._s(_vm._f("moneyFormat")(product))
                                    )
                                  ])
                                ])
                              ])
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _vm.isMobile
        ? _c("div", { staticClass: "end-buttons-container" }, [
            _c(
              "button",
              {
                staticClass: "happybox-button yellow",
                on: {
                  click: function($event) {
                    return _vm.openValidations(false)
                  }
                }
              },
              [_vm._v(_vm._s(_vm.addBtnTxt))]
            ),
            _vm._v(" "),
            _vm.isPreorder
              ? _c("p", { staticClass: "preorder-alert" }, [
                  _vm._v("Ships in time for mid December delivery")
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isMobile
        ? _c("div", { staticClass: "product-legend" }, [
            _c("p", { staticClass: "title" }, [
              _vm._v(
                "Ship exactly how you need. In checkout, you'll be able to:"
              )
            ]),
            _vm._v(" "),
            _vm._m(3),
            _vm._v(" "),
            _vm._m(4),
            _vm._v(" "),
            _vm._m(5)
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.noCard && _vm.recoProducts.length > 0
        ? _c(
            "div",
            { staticClass: "more-gifts" },
            [
              _c("p", { staticClass: "main-title" }, [_vm._v("More Gifts")]),
              _vm._v(" "),
              !_vm.isMobile
                ? _c(
                    "div",
                    { staticClass: "products-container" },
                    _vm._l(_vm.recoProducts, function(product) {
                      return _c(
                        "div",
                        {
                          key: product.id,
                          staticClass: "product-container",
                          on: {
                            click: function($event) {
                              return _vm.selectNewProduct(product)
                            }
                          }
                        },
                        [
                          _c("img", {
                            attrs: { src: _vm._f("getProductImage")(product) }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "curated-footer" }, [
                            _c("div", { staticClass: "curated-desc" }, [
                              _c("p", { staticClass: "title" }, [
                                _vm._v(_vm._s(product.title))
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "price" }, [
                                _vm._v(_vm._s(_vm._f("moneyFormat")(product)))
                              ])
                            ])
                          ])
                        ]
                      )
                    }),
                    0
                  )
                : _vm.recoProducts.length > 0
                ? _c(
                    "VueSlickCarousel",
                    {
                      attrs: {
                        infinite: true,
                        dots: true,
                        arrows: false,
                        slidesToShow: 2,
                        slidesToScroll: 1
                      }
                    },
                    _vm._l(_vm.recoProducts, function(product) {
                      return _c(
                        "div",
                        {
                          key: product.id,
                          staticClass: "product-container",
                          on: {
                            click: function($event) {
                              return _vm.selectNewProduct(product)
                            }
                          }
                        },
                        [
                          _c("img", {
                            attrs: { src: _vm._f("getProductImage")(product) }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "curated-footer" }, [
                            _c("div", { staticClass: "curated-desc" }, [
                              _c("p", { staticClass: "title" }, [
                                _vm._v(_vm._s(product.title))
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "price" }, [
                                _vm._v(_vm._s(_vm._f("moneyFormat")(product)))
                              ])
                            ])
                          ])
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "more-categories" },
        [
          _c("p", { staticClass: "main-title" }, [
            _vm.currentCategory != ""
              ? _c("span", [
                  _vm._v(
                    "Not interested in " + _vm._s(_vm.currentCategory) + " "
                  )
                ])
              : _vm._e(),
            _vm._v(" Here are more categories...")
          ]),
          _vm._v(" "),
          !_vm.isMobile
            ? _c(
                "div",
                { staticClass: "categories-container" },
                _vm._l(_vm.filteredCategories, function(category) {
                  return _c(
                    "div",
                    {
                      key: category.handle,
                      staticClass: "category-container",
                      on: {
                        click: function($event) {
                          return _vm.changeCategory(category.handle)
                        }
                      }
                    },
                    [
                      _c("img", { attrs: { src: category.src } }),
                      _vm._v(" "),
                      _c("p", { staticClass: "title" }, [
                        _vm._v(_vm._s(category.name))
                      ])
                    ]
                  )
                }),
                0
              )
            : _vm.filteredCategories.length > 0
            ? _c(
                "VueSlickCarousel",
                {
                  attrs: {
                    infinite: true,
                    dots: true,
                    arrows: false,
                    slidesToShow: 4,
                    slidesToScroll: 4
                  }
                },
                _vm._l(_vm.filteredCategories, function(category) {
                  return _c(
                    "div",
                    {
                      key: category.handle,
                      staticClass: "category-container",
                      on: {
                        click: function($event) {
                          return _vm.changeCategory(category.handle)
                        }
                      }
                    },
                    [
                      _c("img", { attrs: { src: category.src } }),
                      _vm._v(" "),
                      _c("p", { staticClass: "title" }, [
                        _vm._v(_vm._s(category.name))
                      ])
                    ]
                  )
                }),
                0
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.boxModal
        ? _c("BoxSelectionModal", {
            attrs: { boxQty: _vm.boxQty },
            on: { close: _vm.closeBoxModal, addcart: _vm.addToCart }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.filteredProducts.length < 1
        ? _c("div", { staticClass: "global-spinner-container" }, [
            _c("p", [_vm._v("amazing gifts are loading...")]),
            _vm._v(" "),
            _c("div", { staticClass: "global-spinner" })
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "subcopy" }, [
      _c("img", {
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/houses.svg?v=1695923939"
        }
      }),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "\n                        Bulk ship to one location, ship to many individual addresses, or a mix of both!\n                    "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "subcopy postcard" }, [
      _c("img", {
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/mail_615fe479-4bae-43fe-973f-196e3ac36a33.svg?v=1695923940"
        }
      }),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "\n                        Ship with just an email address. (no physical address needed)\n                    "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "subcopy box-wing" }, [
      _c("img", {
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/flybox.svg?v=1695923939"
        }
      }),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "Select your shipping speed: rush or standard, international or domestic."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "subcopy" }, [
      _c("img", {
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/house_1bdaf796-2917-4938-9706-c759acf6e720.svg?v=1700074183"
        }
      }),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "\n                Bulk ship to one location, ship to many individual addresses, or a mix of both!\n            "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "subcopy postcard" }, [
      _c("img", {
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/mail_2dc82d09-387b-4432-b70d-a8d03f7099d7.svg?v=1700074183"
        }
      }),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "\n                Ship with just an email address. (no physical address needed)\n            "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "subcopy box-wing" }, [
      _c("img", {
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/wings.svg?v=1700074183"
        }
      }),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "Select your shipping speed: rush or standard, international or domestic."
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }